import { normalizeCredentialFields } from './credentialFields';
import { buildGatewayRateRules } from './paymentGatewayPayload';

const normalizeGroupLinks = (links = []) => (
  Array.isArray(links)
    ? links.map((link, index) => (
        typeof link === 'string'
          ? { name: `Link ${index + 1}`, url: link }
          : { name: link?.name || `Link ${index + 1}`, url: link?.url || link?.link || '' }
      )).filter(link => link.url)
    : []
);

const buildEnvDefaults = (provider) => {
  const credentialFields = [
    ...normalizeCredentialFields(provider?.api_credential_keys),
    ...normalizeCredentialFields(provider?.bo_credential_keys)
  ];
  const callbackPaths = {};
  (provider?.callback_urls || []).forEach(callback => {
    if (callback?.name) callbackPaths[callback.name] = callback.path || '';
  });

  const env = {
    bo_urls: [''],
    api_urls: [''],
    callback_paths: callbackPaths
  };
  credentialFields.forEach(field => {
    env[field.key] = field.defaultValue || '';
  });
  return env;
};

export const buildDefaultProviderChangeConfig = (provider) => ({
  selling_rate: 0,
  ...(provider?.paymentGateway ? { selling_rate_rules: buildGatewayRateRules(provider, [], 0) } : {}),
  is_client_line: false,
  status: 'draft',
  group_links: normalizeGroupLinks(provider?.group_links),
  credentials: {
    production: buildEnvDefaults(provider),
    staging: buildEnvDefaults(provider)
  }
});

export const mergeProviderChangeConfig = (provider, overrides = {}) => {
  const defaults = buildDefaultProviderChangeConfig(provider);
  return {
    ...defaults,
    ...overrides,
    ...(provider?.paymentGateway ? { selling_rate_rules: overrides.selling_rate_rules === null ? null : buildGatewayRateRules(provider, overrides.selling_rate_rules, overrides.selling_rate ?? 0) } : {}),
    credentials: Object.fromEntries(['production', 'staging'].map(env => [env, {
      ...defaults.credentials[env],
      ...overrides.credentials?.[env],
      callback_paths: { ...defaults.credentials[env].callback_paths, ...overrides.credentials?.[env]?.callback_paths }
    }]))
  };
};

export const buildExistingProviderChangeConfig = (provider, existingConfig) => {
  const defaults = buildDefaultProviderChangeConfig(provider);
  return {
    selling_rate: existingConfig.selling_rate,
    ...(provider?.paymentGateway ? { selling_rate_rules: existingConfig.selling_rate_rules === null ? null : buildGatewayRateRules(provider, existingConfig.selling_rate_rules, existingConfig.selling_rate ?? 0) } : {}),
    is_client_line: existingConfig.is_client_line,
    status: existingConfig.status || (existingConfig.is_active ? 'active' : 'inactive'),
    group_links: normalizeGroupLinks(existingConfig.group_links),
    credentials: {
      ...existingConfig.credentials,
      ...Object.fromEntries(['production', 'staging'].map(env => [env, {
        ...defaults.credentials[env],
        ...(existingConfig.credentials?.[env] || {})
      }]))
    }
  };
};

